import { render, staticRenderFns } from "./delete_button.vue?vue&type=template&id=0255f487&lang=pug"
import script from "./delete_button.vue?vue&type=script&lang=js"
export * from "./delete_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports